import localStorageCache from 'utils/localStorageCache'
import { SEARCH_CONVERSION, SEARCH_TOKEN_URL } from 'libs/config'
import getWithInMemoryCache from 'utils/getWithInMemoryCache'

module.exports = function () {
  const content = localStorageCache.getItemAndRemove(SEARCH_CONVERSION)
  if (window.aa !== undefined && content !== null) {
    const CONVERSION_TIME = 30000
    getWithInMemoryCache(SEARCH_TOKEN_URL, {}).then(data => {
      window.aa('init', {
        applicationID: data['client_id'],
        apiKey: data.token
      })

      setTimeout(function recordConversion () {
        window.aa('conversion', {
          objectID: content.objectID,
          queryID: content.queryID
        })
      }, CONVERSION_TIME)
    })
  }
}
